function getNbHitsByIndex(allSearchResults, indexName) {
    var ref;
    if (!allSearchResults) {
        return 0;
    }
    if (!indexName) {
        var _nbHits;
        return (_nbHits = allSearchResults.nbHits) !== null && _nbHits !== void 0 ? _nbHits : 0;
    }
    var ref1;
    return (ref1 = (ref = allSearchResults[indexName]) === null || ref === void 0 ? void 0 : ref.nbHits) !== null && ref1 !== void 0 ? ref1 : 0;
}

export { getNbHitsByIndex };
//# sourceMappingURL=get-hits-by-index.js.map
